import React, { useState } from 'react';
import { Upload } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const SortableUpload = ({ fileList = [], onChange, ...props }) => {
  const [internalFileList, setInternalFileList] = useState(fileList);

  // 监听外部fileList变化
  React.useEffect(() => {
    setInternalFileList(fileList);
  }, [fileList]);

  // 向左移动元素（在数组中向前移动）
  const moveLeft = (index) => {
    if (index <= 0) return;
    
    const newFileList = [...internalFileList];
    [newFileList[index], newFileList[index - 1]] = [newFileList[index - 1], newFileList[index]];
    
    setInternalFileList(newFileList);
    onChange && onChange({ file: newFileList[index], fileList: newFileList });
  };

  // 向右移动元素（在数组中向后移动）
  const moveRight = (index) => {
    if (index >= internalFileList.length - 1) return;
    
    const newFileList = [...internalFileList];
    [newFileList[index], newFileList[index + 1]] = [newFileList[index + 1], newFileList[index]];
    
    setInternalFileList(newFileList);
    onChange && onChange({ file: newFileList[index], fileList: newFileList });
  };

  // 渲染带箭头的上传项
  const renderSortableItem = (originNode, file, index) => {
    return (
      <div className="sortable-upload-item">
        <div>
          {originNode}
        </div>
        <div className="sort-controls" style={{ display: 'flex', justifyContent: 'center', gap: 8, margin: '2px 0 0 0' }}>
          <button 
            className="sort-btn sort-left"
            onClick={() => moveLeft(index)}
            disabled={index === 0}
            style={{
              width: 24,
              height: 20,
              border: '1px solid #d9d9d9',
              background: '#f5f5f5',
              cursor: index === 0 ? 'not-allowed' : 'pointer',
              borderRadius: 4,
              fontSize: 12,
              opacity: index === 0 ? 0.5 : 1
            }}
          >
            <ArrowLeftOutlined />
          </button>
          <button 
            className="sort-btn sort-right"
            onClick={() => moveRight(index)}
            disabled={index === internalFileList.length - 1}
            style={{
              width: 24,
              height: 20,
              border: '1px solid #d9d9d9',
              background: '#f5f5f5',
              cursor: index === internalFileList.length - 1 ? 'not-allowed' : 'pointer',
              borderRadius: 4,
              fontSize: 12,
              opacity: index === internalFileList.length - 1 ? 0.5 : 1
            }}
          >
            <ArrowRightOutlined style={{fontSize: 12}} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <Upload
      {...props}
      fileList={internalFileList}
      onChange={({ file, fileList }) => {
        setInternalFileList(fileList);
        // 调用原始的onChange回调
        onChange && onChange({ file, fileList });
      }}
      itemRender={(originNode, file) => {
        // 获取文件在列表中的索引
        const index = internalFileList.findIndex(item => item.uid === file.uid);
        // 返回带箭头的渲染项
        return renderSortableItem(originNode, file, index);
      }}
    />
  );
};

export default SortableUpload;